import { BaseComponent } from '../base-component.js';
import { toast } from '../../client/toast.js';
import { escapeHtml } from '../../shared/utils.js';
import componentStyles from './toast-container.css?inline';

interface Toast {
  id: string;
  type: 'success' | 'error' | 'warning' | 'info';
  message: string;
  duration: number;
}

export class ToastContainer extends BaseComponent {
  private toasts: Toast[] = [];
  private unsubscribe?: () => void;

  connectedCallback(): void {
    super.connectedCallback();
    this.unsubscribe = toast.subscribe((toasts) => {
      this.toasts = toasts;
      this.render();
      this.afterRender();
    });
  }

  disconnectedCallback(): void {
    this.unsubscribe?.();
  }

  protected styles(): string {
    return componentStyles;
  }

  protected template(): string {
    if (this.toasts.length === 0) {
      return '';
    }

    return `
      <div class="toast-list">
        ${this.toasts.map(t => this.renderToast(t)).join('')}
      </div>
    `;
  }

  private renderToast(t: Toast): string {
    const icon = this.getIcon(t.type);
    const safeMessage = escapeHtml(t.message);

    return `
      <div class="toast toast-${t.type}" data-id="${t.id}">
        <span class="toast-icon">${icon}</span>
        <div class="toast-content">${safeMessage}</div>
        <button class="toast-close" data-id="${t.id}" aria-label="Close">×</button>
      </div>
    `;
  }

  private getIcon(type: string): string {
    switch (type) {
      case 'success': return '✓';
      case 'error': return '✕';
      case 'warning': return '⚠';
      case 'info': return 'ⓘ';
      default: return 'ⓘ';
    }
  }

  protected afterRender(): void {
    this.$all('.toast-close').forEach(btn => {
      btn.addEventListener('click', (e: Event) => {
        const id = (e.target as HTMLElement).getAttribute('data-id');
        if (id) {
          const toastEl = this.$(`[data-id="${id}"]`);
          toastEl?.classList.add('removing');
          setTimeout(() => toast.dismiss(id), 300);
        }
      });
    });
  }
}

customElements.define('toast-container', ToastContainer);
